
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.163 7.585a1.877 1.877 0 100-3.755 1.877 1.877 0 000 3.755z","fill":"#7B01B5"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.908 0h-3.98a7.51 7.51 0 00-7.51 7.51v3.98A7.51 7.51 0 007.928 19h3.98a7.51 7.51 0 007.51-7.51V7.51A7.51 7.51 0 0011.908 0zm-3.98 1.408h3.98a6.102 6.102 0 016.036 5.276H16.49a11.04 11.04 0 00-9.519 5.463 6.965 6.965 0 00-4.346-1.511h-.798V7.51a6.111 6.111 0 016.102-6.102zM2.624 12.044h-.77a6.102 6.102 0 003.633 5.032c.067-1.254.35-2.486.836-3.643a5.632 5.632 0 00-3.699-1.389zm9.284 5.548h-3.98a5.63 5.63 0 01-1.052-.103 9.631 9.631 0 019.613-9.416h1.52v3.417a6.111 6.111 0 01-6.1 6.102z","fill":"#7B01B5"}})])
          )
        }
      }
    